import { Link } from 'react-router-dom'

import { Box } from 'app/components/design-system-components'
import { urlTo } from 'app/sm/helpers'

function InProgressAppContinue({
  inProgressApplicationCount = 0,
  firstApplicationFriendlyName = '',
  firstApplicationGUID = '',
}) {
  return (
    <Box>
      {inProgressApplicationCount === 1 ? (
        <>
          Complete your draft application for{' '}
          <Link
            to={urlTo('application', {
              applicationId: firstApplicationGUID,
            })}
          >
            {firstApplicationFriendlyName}
          </Link>
        </>
      ) : (
        <>
          Complete your draft application for{' '}
          <Link to={urlTo('applications')}>
            {firstApplicationFriendlyName} and {inProgressApplicationCount - 1}{' '}
            others
          </Link>
        </>
      )}
    </Box>
  )
}

export default InProgressAppContinue
